import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, vShow as _vShow, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  key: 1,
  class: "h-full"
}
const _hoisted_2 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400" }
const _hoisted_3 = { class: "flex flex-row my-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4 text-black-lp-200" }, " Edit Commodity Surcharge ", -1)
const _hoisted_5 = { class: "inline-flex" }
const _hoisted_6 = { class: "flex flex-row h-full" }
const _hoisted_7 = { class: "w-2/3 px-4 text-12px xxl:text-14px overflow-y-auto pb-24" }
const _hoisted_8 = { class: "pt-4" }
const _hoisted_9 = { class: "py-3 w-3/4" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Nama Komoditas", -1)
const _hoisted_11 = { class: "inline-block relative w-full my-2 mr-4" }
const _hoisted_12 = { class: "flex flex-row w-3/4" }
const _hoisted_13 = { class: "py-3 w-2/3 mr-4" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 pb-2" }, " Tipe Biaya ", -1)
const _hoisted_15 = { class: "flex flex-row w-3/4" }
const _hoisted_16 = { class: "py-3 w-1/2 mr-4" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 pb-2 flex flex-row space-x-2" }, [
  /*#__PURE__*/_createVNode("p", { class: "whitespace-no-wrap" }, "Nilai Biaya")
], -1)
const _hoisted_18 = { class: "flex flex-row items-center relative w-1/2" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-700 rounded-r-md text-black-lp-300 text-center my-1.5 border-gray-lp-400 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2" }, " % ", -1)
const _hoisted_20 = { class: "flex flex-row items-center relative w-1/2" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-700 rounded-l-md text-black-lp-300 text-center my-1.5 border-gray-lp-400 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2" }, " IDR ", -1)
const _hoisted_22 = { class: "py-3 w-3/4" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Objek Tambahan ", -1)
const _hoisted_24 = { class: "mt-4 pt-4 border-t border-gray-lp-400" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "py-2 text-20px text-gray-lp-300 font-semibold" }, " Target Kota Asal dan Tujuan ", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "text-12px text-gray-lp-500 w-3/4" }, " Komoditas denga target kota asal dan kota tujuan yang sudah memiliki Commodity Surcharge tidak dapat dibuat kembali sampai status inactive. ", -1)
const _hoisted_27 = { class: "py-3 w-3/4" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Kota Asal", -1)
const _hoisted_29 = { class: "inline-block relative w-full my-2 mr-4" }
const _hoisted_30 = { class: "py-3 w-3/4" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Kota Tujuan", -1)
const _hoisted_32 = { class: "inline-block relative w-full my-2 mr-4" }
const _hoisted_33 = { class: "mt-4 pt-4 border-t border-gray-lp-400" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "py-2 text-20px text-gray-lp-300 font-semibold" }, " Periode Commodity Surcharge ", -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "text-gray-lp-500 text-12px" }, " Commodity Surcharge akan berlaku sesuai dengan tanggal periode yang dipilih. ", -1)
const _hoisted_36 = { class: "flex flex-row w-3/5 py-3" }
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createVNode("div", { class: "w-13/20 mr-4" }, [
    /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 mb-2" }, " Dimulai Dari ")
  ])
], -1)
const _hoisted_38 = { class: "flex flex-col mr-4" }
const _hoisted_39 = { class: "text-red-lp-100 text-12px xxl:text-14px" }
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "flex flex-col" }, [
  /*#__PURE__*/_createVNode("div", { class: "w-13/20 mr-4" }, [
    /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 mb-2" }, " Sampai ")
  ])
], -1)
const _hoisted_41 = { class: "flex flex-col mr-4" }
const _hoisted_42 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400" }
const _hoisted_43 = { class: "py-3" }
const _hoisted_44 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Status Commodity Surcharge ", -1)
const _hoisted_45 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_46 = { class: "flex" }
const _hoisted_47 = { class: "capitalize" }
const _hoisted_48 = { class: "py-3" }
const _hoisted_49 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tanggal Dibuat", -1)
const _hoisted_50 = { class: "my-1 text-black-lp-300" }
const _hoisted_51 = { class: "text-gray-lp-500" }
const _hoisted_52 = { class: "py-3" }
const _hoisted_53 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Terakhir Diubah", -1)
const _hoisted_54 = { class: "my-1 text-black-lp-300" }
const _hoisted_55 = { class: "text-gray-lp-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Select = _resolveComponent("Select")!
  const _component_multiple_select_search = _resolveComponent("multiple-select-search")!
  const _component_Pickers = _resolveComponent("Pickers")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
          key: 0,
          onBack: _ctx.goBack
        }, null, 8, ["onBack"]))
      : (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("img", {
                src: _imports_0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
                class: "w-5 mr-3 cursor-pointer",
                alt: "arrow-left"
              }),
              _hoisted_4
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_button_fill, {
                title: "Simpan",
                onClick: _ctx.onOpenSave,
                class: `px-8 bg-red-lp-300`,
                isDisabled: _ctx.isDisabledSave
              }, null, 8, ["onClick", "isDisabled"])
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode("div", _hoisted_11, [
                    _createVNode("input", {
                      class: "block appearance-none text-12px xxl:text-14px w-full text-black-lp-300 bg-white border border-gray-lp-400 px-4 py-2 pr-16 rounded shadow leading-tight focus:outline-none",
                      maxlength: 56,
                      placeholder: _ctx.dataDetail.commodityName,
                      disabled: true
                    }, null, 8, ["placeholder"])
                  ])
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_Select, {
                      dataSelect: _ctx.typeData,
                      onOpenSelect: _ctx.onOpenTypeChargeSelect,
                      onCloseSelect: _ctx.onCloseTypeChargeSelect,
                      onChooseSelect: _ctx.onSelectTypeCharge,
                      value: _ctx.typeChargeName,
                      isOpenMenu: _ctx.typeChargeSelect,
                      class: "w-full z-10"
                    }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
                  ])
                ]),
                _createVNode("div", _hoisted_15, [
                  _createVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _withDirectives(_createVNode("div", null, [
                      _createVNode("div", _hoisted_18, [
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "py-1.5 xxl:py-3 px-3 rounded-r-none rounded-l-md border border-gray-lp-400 focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-full",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dataDetail.amount = $event)),
                          onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onInputFormatRupiah(_ctx.minPrice))),
                          onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"]))
                        }, null, 544), [
                          [_vModelText, _ctx.dataDetail.amount]
                        ]),
                        _hoisted_19
                      ])
                    ], 512), [
                      [_vShow, _ctx.typeChargeValue === 'percentage']
                    ]),
                    _withDirectives(_createVNode("div", null, [
                      _createVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "py-1.5 xxl:py-3 px-3 rounded-l-none rounded-r-md border border-gray-lp-400 focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-full",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dataDetail.amount = $event)),
                          onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onInputFormatRupiah(_ctx.minPrice))),
                          onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"]))
                        }, null, 544), [
                          [_vModelText, _ctx.dataDetail.amount]
                        ])
                      ])
                    ], 512), [
                      [_vShow, 
                  _ctx.typeChargeValue === 'per_kg' || _ctx.typeChargeValue === 'flat'
                ]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_22, [
                  _hoisted_23,
                  (_ctx.typeChargeValue.toLowerCase() === 'percentage')
                    ? (_openBlock(), _createBlock(_component_multiple_select_search, {
                        key: 0,
                        options: _ctx.addObjectOptionsData,
                        modelValue: _ctx.additionalObject,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.additionalObject = $event)),
                        keyName: "name",
                        keyValue: "value",
                        placeholder: "Ketik atau pilih Objek Tambahan",
                        onFilter: _ctx.onSearchAddObject
                      }, null, 8, ["options", "modelValue", "onFilter"]))
                    : _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.addObject = $event)),
                        onInput: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.filterInputAddObject && _ctx.filterInputAddObject(...args))),
                        class: "block appearance-none my-2 text-12px xxl:text-14px w-full text-black-lp-300 bg-white border border-gray-lp-400 px-4 py-2 pr-16 rounded shadow leading-tight focus:outline-none opacity-50",
                        maxlength: 56,
                        placeholder: "Volume Barang",
                        disabled: ""
                      }, null, 544)), [
                        [_vModelText, _ctx.addObject]
                      ])
                ])
              ]),
              _createVNode("div", _hoisted_24, [
                _hoisted_25,
                _hoisted_26,
                _createVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createVNode("div", _hoisted_29, [
                    _createVNode("input", {
                      class: "block appearance-none text-12px xxl:text-14px w-full text-black-lp-300 bg-white border border-gray-lp-400 px-4 py-2 pr-16 rounded shadow leading-tight focus:outline-none",
                      maxlength: 56,
                      placeholder: _ctx.dataDetail.originCityCode,
                      disabled: true
                    }, null, 8, ["placeholder"])
                  ])
                ]),
                _createVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createVNode("div", _hoisted_32, [
                    _createVNode("input", {
                      class: "block appearance-none text-12px xxl:text-14px w-full text-black-lp-300 bg-white border border-gray-lp-400 px-4 py-2 pr-16 rounded shadow leading-tight focus:outline-none",
                      maxlength: 56,
                      placeholder: _ctx.dataDetail.destinationCityCode,
                      disabled: true
                    }, null, 8, ["placeholder"])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_33, [
                _hoisted_34,
                _hoisted_35,
                _createVNode("div", _hoisted_36, [
                  _createVNode("div", null, [
                    _hoisted_37,
                    _createVNode("div", _hoisted_38, [
                      _createVNode(_component_Pickers, {
                        modelValue: _ctx.periodeStart,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.periodeStart = $event)),
                        class: `${_ctx.invalidStartDate && 'date-error'}`,
                        minDate: _ctx.pastStartDate,
                        disabled: true,
                        onSelected: _ctx.setPeriodeStart
                      }, null, 8, ["modelValue", "class", "minDate", "onSelected"]),
                      _withDirectives(_createVNode("span", _hoisted_39, "Tanggal mulai tidak boleh lebih atau sama dengan tanggal akhir", 512), [
                        [_vShow, _ctx.invalidStartDate]
                      ])
                    ])
                  ]),
                  _createVNode("div", null, [
                    _hoisted_40,
                    _createVNode("div", _hoisted_41, [
                      _createVNode(_component_Pickers, {
                        modelValue: _ctx.periodeEnd,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.periodeEnd = $event)),
                        minDate: 
                    new Date(
                      new Date(_ctx.periodeStart).setDate(
                        new Date(_ctx.periodeStart).getDate() + 1
                      )
                    )
                  ,
                        maxDate: _ctx.pastEndDate,
                        onSelected: _ctx.setPeriodeEnd
                      }, null, 8, ["modelValue", "minDate", "maxDate", "onSelected"])
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_42, [
              _createVNode("div", _hoisted_43, [
                _hoisted_44,
                _createVNode("div", _hoisted_45, [
                  _createVNode("div", _hoisted_46, [
                    _createVNode("div", {
                      class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.dataDetail.status.toLowerCase() === 'active'
                      ? 'bg-green-lp-300'
                      : _ctx.dataDetail.status.toLowerCase() === 'inactive'
                      ? 'bg-red-lp-600'
                      : 'bg-yellow-lp-200'
                  } ${
                    _ctx.dataDetail.status.toLowerCase() === 'active'
                      ? 'text-green-lp-200'
                      : _ctx.dataDetail.status.toLowerCase() === 'inactive'
                      ? 'text-red-lp-500'
                      : 'text-yellow-lp-100'
                  }`
                
                    }, [
                      _createVNode("span", _hoisted_47, _toDisplayString(_ctx.dataDetail.status.toLowerCase() === "pending"
                      ? "Upcoming"
                      : _ctx.dataDetail.status.toLowerCase() === "inactive"
                      ? "Inactive"
                      : "Active"), 1)
                    ], 2)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_48, [
                _hoisted_49,
                _createVNode("div", _hoisted_50, _toDisplayString(_ctx.createdAt), 1),
                _createVNode("div", _hoisted_51, _toDisplayString(_ctx.createdBy), 1)
              ]),
              _createVNode("div", _hoisted_52, [
                _hoisted_53,
                _createVNode("div", _hoisted_54, _toDisplayString(_ctx.updateAt), 1),
                _createVNode("div", _hoisted_55, _toDisplayString(_ctx.updateBy), 1)
              ])
            ])
          ])
        ])),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.goBack,
      title: "Perubahan Disimpan",
      message: 
      `Commodity Surcharge “${_ctx.dataDetail.commodityName}” berhasil diubah`
    ,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: "Yakin ingin keluar?",
      message: "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx._onEdit,
      onClose: _ctx.onCloseSave,
      title: "Konfirmasi Perubahan Commodity Surcharge",
      message: 
      `Anda yakin akan menyimpan perubahan untuk Commodity Surcharge “${_ctx.dataDetail.commodityName}”`
    ,
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "message"]), [
      [_vShow, _ctx.openSave]
    ])
  ], 64))
}